import { Box, DialogContent, Stack } from "@mui/material";
import { environmentConfig } from "@src/appV2/environment";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { PageHeaderWrapper, Text, Title } from "@src/appV2/redesign/system/ui-components";

const VERIFIED_IMAGE_URL = `${environmentConfig.REACT_APP_PUBLIC_ASSETS_BASE_URL}/images/badge-policy/idealBadgeSelfie.png`;

export interface BadgeVerificationTakePhotoContentProps {
  isSubmitting?: boolean;
  onBack: () => void;
  onNoBadge: () => void;
  onTakePhoto: () => void;
  onWhyBadgeRequired?: () => void;
}

export function BadgeVerificationTakePhotoContent(props: BadgeVerificationTakePhotoContentProps) {
  const { isSubmitting = false, onBack, onTakePhoto, onNoBadge, onWhyBadgeRequired } = props;

  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow onClickBack={onBack} />
      </PageHeaderWrapper>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 5,
        }}
      >
        <Stack spacing={10} alignItems="center" sx={{ width: "100%" }}>
          <Stack spacing={3} alignItems="center" sx={{ textAlign: "center" }}>
            <Title semibold component="h1" variant="h4">
              Take a selfie with your badge on your work attire
            </Title>
            <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
              Your badge should display your name and role so staff and residents can identify you
              easily.
            </Text>
          </Stack>

          <Stack spacing={5} alignItems="center" sx={{ width: "100%" }}>
            <Box
              component="img"
              src={VERIFIED_IMAGE_URL}
              alt="Example of a worker wearing a badge"
              sx={(theme) => ({
                width: "100%",
                // this looks weird on larger screens if the width is too large
                maxWidth: 280,
                height: 280,
                objectFit: "cover",
                objectPosition: "center bottom",
                borderRadius: theme.borderRadius?.xSmall,
              })}
            />
            {onWhyBadgeRequired && (
              <TextButton size="large" onClick={onWhyBadgeRequired}>
                View badge policy
              </TextButton>
            )}
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <LoadingButton
          fullWidth
          variant="contained"
          size="large"
          isLoading={isSubmitting}
          onClick={onTakePhoto}
        >
          Verify my badge
        </LoadingButton>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          disabled={isSubmitting}
          onClick={onNoBadge}
        >
          I don't have a badge
        </Button>
      </DialogFooter>
    </>
  );
}
